module.exports = __webpack_public_path__ + "img/assistant.4efd7d03.png";